import { type ActionReducerMapBuilder, createAction } from "@reduxjs/toolkit";

export const resetStore = createAction("RESET_STORE");

const extraReducers =
  <T>(initialState: T) =>
  (builder: ActionReducerMapBuilder<T>) => {
    builder.addCase(resetStore, () => initialState);
  };

export default extraReducers;
